<template>
  <div class="task-container">
    <div class="row col-md-12">
      <table id="accountNotesTable" class="table table-striped table-hover">
        <thead>
        <th>Note</th>
        <th>Attachment</th>
        <th>Added By</th>
        <th>Created At</th>
        <th>Action</th>
        </thead>
        <tbody>
        <tr v-for="(row, index) of accountNotes" :key="index">
          <td>
            <span v-html="row.text"></span>
          </td>
          <td>
            <a v-if="row.imageUrl" :href="row.imageUrl" target="_blank">{{ row.fileName }}</a>
          </td>
          <td>
            {{row.addedBy}}
          </td>
          <td>{{row.createdAt | formatDate}}</td>
          <td>
            <button :disabled="selectedIndex === index" @click="deleteNote(index, row)" class="btn btn-sm btn-danger my-1"><i class="fa fa-trash"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ this.pageCount }}
                </span>
        <section class="dataTables_paginate paging_full_numbers">
          <paginate
              :pageCount="pageCount"
              :clickHandler="goToPage"
              :prevText="'Prev'"
              :nextText="'Next'"
              page-class="page-item"
              prev-class="page-item"
              prev-link-class="page-link"
              next-class="page-item"
              next-link-class="page-link"
              page-link-class="page-link"
              containerClass="pagination">
          </paginate>
        </section>
      </div>
    </div>

  </div>
</template>

<script>
import {db, storage} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import swal from "sweetalert2";
export default {
  name: "list",
  components: {
    Paginate
  },
  mounted() {
    console.log('inside mounted');
  },
  data () {
    return {
      pageNumber: 0,
      showRecords: 10,
      loading: false,
      selectedIndex: -1
    }
  },
  computed: {
    pageCount () {
      let l = parseInt(this.accountNotes.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },
  },
  props: {
    docId: {
      type: String
    },
    accountNotes: {
      type: Array
    }
  },
  methods: {
    async deleteNote (index, row) {
      try {
        this.selectedIndex = index;
        let notes = JSON.parse(JSON.stringify(this.accountNotes));
        notes.splice(index, 1)
        if (row.imageUrl) {
          const fileRef = storage.refFromURL(row.imageUrl);
          if (fileRef) {
            fileRef.delete();
          }
        }
        await db.collection('accountNotes').doc(this.docId).update({notes});
        await this.$parent.getAllAccountNotes()
        swal({
          title: "Success",
          text: "Account note has been deleted successfully!",
          type: "success",
        });
      } catch (e) {
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while deleting account notes!",
          type: "error",
        });
      }
      finally {
        this.selectedIndex = -1;
        this.loading = false;
      }

    },
    goToPage (pageNum) {
      this.pageNumber = pageNum - 1;
    },
  }
}
</script>

<style scoped>

</style>